import { TTask } from "@/types";

import API from "./api";

class TasksClass {
	fetchTask = (taskId: number) => {
		return API.get(`tasks/${taskId}`).then((res) => res.data);
	};

	createTask = (task: Partial<TTask>) => {
		return API.post(`tasks`, task).then((res) => res.data);
	};

	updateTask = (task: Partial<TTask>) => {
		return API.put(`tasks/${task.id}`, task).then((res) => res.data);
	};

	deleteTask = (taskId: string) => {
		return API.delete(`tasks/${taskId}`).then((res) => res.data);
	};

	deleteTasks = (taskIds: string[]) => {
		return API.delete(`tasks/batch-delete`, {
			data: taskIds,
		}).then((res) => res.data);
	};
}

const TasksService = new TasksClass();
export default TasksService;
